<sf-filter (searchFired)="search()" (resetFired)="reset()" [isCollapsed]="true" [isCollapsable]="true">
    <form [formGroup]="filterForm">
        <div class="row">
            <div class="col-lg-8">
                <div class="row">
                    <div class="col-md-4 col-xl-3">
                        <sf-input-group-button
                            label="Customer Id"
                            inputId="customerId"
                            formControlName="customerId"
                            buttonLabel="Find"
                            (buttonClick)="openCustomerSearch()"></sf-input-group-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <sf-calendar-range-selector formControlName="dateRangeFilter"></sf-calendar-range-selector>
            </div>
        </div>
    </form>
</sf-filter>
